function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import append from 'ramda/src/append';
import filter from 'ramda/src/filter';
import find from 'ramda/src/find';
import path from 'ramda/src/path';
import pathOr from 'ramda/src/pathOr';
import propEq from 'ramda/src/propEq';
import reject from 'ramda/src/reject';
import { stateGo } from 'redux-ui-router';
import Immutable from 'seamless-immutable';
import { AngularFormControllerErrorAdapter, LogHelper, i18n, MetadataActions, MetadataConstants, MetadataSelectors, PermissionService, SessionSelectors, UnsavedChangesPromptActions } from 'invision-core';
import { NOTIFICATION_TIME_LENGTH } from '../../../customercare.constants';
import { CASE_STATUS, CASE_CATEGORIES } from '../cases/list/case.constants';
import { createCase, fetchCaseTypes, removeCaseSelectedCategoryId, retrieveCase, setCaseEditMode, updateCase, updateCaseInventoryItem, updateCaseSelectedCategoryId } from '../../../reducers/actions/customer.cases.actions';
import { transformCaseForService, shouldHaveResolutionText } from './transform.case.helper';
import { CurrentCustomerIdSelector } from '../../../reducers/selectors/customer.selectors';
import { CaseTypesSelector, CaseFormIsInvalidSelector, CasesErrorSelector, CustomerInvoicesSelector, CustomFieldsFromCurrentCategorySelector, FormattedCaseStatusCodeSelector, FormattedInvoicesSelector, IsCreatingCaseSelector, IsUpdatingCaseSelector } from '../../../reducers/selectors/customer.cases.selectors';
import { CaseInventoryOptionsSelector, SelectedCaseInventorySelector } from '../../../reducers/selectors/customer.inventory.selectors';
import CustomerCareLocaleKeys from '../../../locales/keys';
import { CaseCategoryOptionsSelector, CasePriorityOptionsSelector, CaseSeverityOptionsSelector, DisputeInvoiceCaseTypesOptionsSelector } from './case.modal.selectors';
import { CASE_ACCESS } from '../../../security.attributes';
import { validateNumbers } from 'invision-core/src/utilities/input.helper';
import { CASE_DETAILS_STATE_NAME } from '../cases/detail/detail.config';
function getLabelByValue(predicate, collection) {
  var foundItem = find(propEq(predicate, 'value'))(collection);
  return foundItem ? foundItem.text : '';
}
var CaseModalController = /*#__PURE__*/function () {
  function CaseModalController($ngRedux, $timeout, uiNotificationService, unsavedChangesPrompt, $locale) {
    _classCallCheck(this, CaseModalController);
    Object.assign(this, {
      $locale: $locale,
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      editCase: {},
      formFieldLocaleKeyMapping: {
        priority: CustomerCareLocaleKeys.PRIORITY,
        description: CustomerCareLocaleKeys.DESCRIPTION,
        category: CustomerCareLocaleKeys.CASE_TYPE,
        caseFormStatus: CustomerCareLocaleKeys.STATUS,
        // NOTE: these are only necessary if the case category is 'INVOICE_DISPUTE'
        disputed_amount: CustomerCareLocaleKeys.DISPUTED_AMOUNT,
        invoice_number: CustomerCareLocaleKeys.INVOICE_NUMBER,
        resolutionText: CustomerCareLocaleKeys.RESOLUTION
      },
      invoiceNumber: undefined,
      uiNotificationService: uiNotificationService,
      unsavedChangesPrompt: unsavedChangesPrompt,
      unsavedChangesPromptPopupApi: null,
      validateNumbers: validateNumbers
    });
    this.formFieldLocaleKeyMapping = {
      category: CustomerCareLocaleKeys.CASE_TYPE,
      summary: CustomerCareLocaleKeys.CASE_MODAL.SUMMARY,
      caseFormStatus: CustomerCareLocaleKeys.STATUS,
      resolutionText: CustomerCareLocaleKeys.RESOLUTION,
      disputed_amount: CustomerCareLocaleKeys.DISPUTED_AMOUNT,
      invoice_number: CustomerCareLocaleKeys.INVOICE_NUMBER,
      approved_amount: CustomerCareLocaleKeys.APPROVED_AMOUNT,
      priority: CustomerCareLocaleKeys.PRIORITY,
      severity: CustomerCareLocaleKeys.CASE_MODAL.SEVERITY,
      description: CustomerCareLocaleKeys.DESCRIPTION
    };
    this.formFieldConstraintParameters = {
      maxlength: {
        summary: 100,
        description: 8000
      }
    };
  }
  return _createClass(CaseModalController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentCustomerId: CurrentCustomerIdSelector(store),
          caseTypes: CaseTypesSelector(store),
          caseCategoryCodes: CaseCategoryOptionsSelector(store),
          customFields: CustomFieldsFromCurrentCategorySelector(store),
          disputeInvoiceCaseTypesOptionsSelector: DisputeInvoiceCaseTypesOptionsSelector(store),
          priorities: CasePriorityOptionsSelector(store),
          prioritiesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.CasePriority, store),
          severities: CaseSeverityOptionsSelector(store),
          severitiesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.CaseSeverity, store),
          formattedCaseStatusCodes: FormattedCaseStatusCodeSelector(store),
          regularExpressionValidationsLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.RegularExpression, store),
          formattedInvoices: FormattedInvoicesSelector(store),
          invoices: CustomerInvoicesSelector(store),
          isCreatingCase: IsCreatingCaseSelector(store),
          isInvalid: CaseFormIsInvalidSelector(store),
          isUpdatingCase: IsUpdatingCaseSelector(store),
          lastAttemptError: CasesErrorSelector(store),
          inventory: CaseInventoryOptionsSelector(store),
          selectedInventory: SelectedCaseInventorySelector(store),
          userSecurityAttributes: SessionSelectors.UserSecurityAttributesSelector(store)
        };
      };
      var controllerActions = {
        createCase: createCase,
        fetchCaseTypes: fetchCaseTypes,
        fetchCodeTypes: MetadataActions.codes.fetchCodeTypes,
        fetchCodeTypesThunk: MetadataActions.codes.fetchCodeTypesThunk,
        registerUnsavedChanges: UnsavedChangesPromptActions.registerUnsavedChanges,
        removeCaseSelectedCategoryId: removeCaseSelectedCategoryId,
        retrieveCase: retrieveCase,
        setCaseEditMode: setCaseEditMode,
        stateGo: stateGo,
        updateCase: updateCase,
        updateCaseSelectedCategoryId: updateCaseSelectedCategoryId,
        updateCaseInventoryItem: updateCaseInventoryItem,
        unregisterUnsavedChanges: UnsavedChangesPromptActions.unregisterUnsavedChanges
      };
      this.showForm = false;
      this.customerCareLocaleKeys = CustomerCareLocaleKeys;
      this.caseCategories = CASE_CATEGORIES;
      this.MIN_INVOICE_DISPUTED_AMOUNT = 1 / Math.pow(10, this.$locale.NUMBER_FORMATS.PATTERNS[1].maxFrac); //Minimal amount value depending on the currency (0.01 in the case of dollars)

      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.deregisterUnsavedChanges = function () {
        _this.actions.unregisterUnsavedChanges('caseModal');
      };
      this.closePopup = function () {
        if (_this.isCreatingCase || _this.state.isUpdatingCase) {
          // app is going to crash; log a User-friendly message for the developer
          LogHelper.debug('closing popup while awaiting async operation');
        }
        _this.deregisterUnsavedChanges();
        _this.popupApi.close();
        _this.actions.removeCaseSelectedCategoryId();
        _this.showForm = false;
      };
      this.handleClose = function () {
        if (_this.unsavedChangesPrompt.hasUnsavedChanges()) {
          _this.unsavedChangesPromptPopupApi.open();
        } else {
          _this.closePopup();
        }
      };
      this.unsavedChangesPromptPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.unsavedChangesPromptPopupApi = api;
        }
      };
      this.handleResultUnsavedChangesPromptPopup = function (confirmed) {
        if (confirmed) {
          _this.closePopup();
        }
        _this.unsavedChangesPromptPopupApi.close();
      };
      this.handleCloseUnsavedChangesPromptPopup = function () {
        _this.unsavedChangesPromptPopupApi.close();
      };
      this.initializeData();
      this.initializePopup();
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "initializeData",
    value: function initializeData() {
      if (!this.state.regularExpressionValidationsLoaded) {
        this.actions.fetchCodeTypes(MetadataConstants.codes.RegularExpression);
      }
      if (!this.state.caseTypes.length && PermissionService.hasAccess(this.state.userSecurityAttributes, CASE_ACCESS)) {
        this.actions.fetchCaseTypes(this.state.currentCustomerId);
      }
      if (!this.state.prioritiesLoaded) {
        this.actions.fetchCodeTypes(MetadataConstants.codes.CasePriority);
      }
      if (!this.state.severitiesLoaded) {
        this.actions.fetchCodeTypes(MetadataConstants.codes.CaseSeverity);
      }
    }
  }, {
    key: "initializePopup",
    value: function initializePopup() {
      var _this2 = this;
      var onRegisterApi = this.config.onRegisterApi;
      this.config.onRegisterApi = function (_ref2) {
        var api = _ref2.api;
        _this2.popupApi = Object.assign({}, api, {
          open: function open(isCloseCase, invoiceNumber) {
            _this2.resetForm();
            _this2.showForm = true;
            _this2.isCloseCase = isCloseCase;
            if (_this2.isCloseCase) {
              var closeCaseText = i18n.translate(CustomerCareLocaleKeys.CASE.CLOSE);
              _this2.modalTitle = closeCaseText;
              _this2.saveButtonText = closeCaseText;
              _this2.editCase.Status = CASE_STATUS.CLOSED;
            }
            _this2.invoiceNumber = invoiceNumber;
            if (_this2.invoiceNumber) {
              _this2.editCase.Details = _objectSpread(_objectSpread({}, pathOr(undefined, ['Details'], _this2.editCase)), {}, {
                InvoiceDisputeDetails: _objectSpread(_objectSpread({}, pathOr(undefined, ['Details', 'InvoiceDisputeDetails'], _this2.editCase)), {}, {
                  InvoiceNumber: _this2.invoiceNumber
                })
              });
            }

            // NOTE: must wait for the ng-if bound to showForm to operate, for the popup centering logic
            _this2.$timeout(function () {
              api.open();
              _this2.actions.registerUnsavedChanges('caseModal', {
                isDirty: function isDirty() {
                  return _this2.formController ? _this2.formController.$dirty : false;
                },
                setPristine: function setPristine() {
                  _this2.formController && _this2.formController.$setPristine();
                }
              });
            });
          }
        });
        onRegisterApi && onRegisterApi({
          api: _this2.popupApi
        });
      };
    }
  }, {
    key: "setCase",
    value: function setCase(caseObj) {
      this.editCase = caseObj;
      this.inEditMode = !!pathOr(false, ['case', 'Id', 'Value'], this);
      this.actions.setCaseEditMode(this.inEditMode);
      this.handleCategoryChange();
      this.selectInvoiceAmounts();
    }
  }, {
    key: "caseCategoryLabel",
    get: function get() {
      return getLabelByValue(this.case && this.case.Category || this.caseType, this.state.caseCategoryCodes);
    }
  }, {
    key: "caseStatusLabel",
    get: function get() {
      return getLabelByValue(this.editCase.Status, this.state.formattedCaseStatusCodes);
    }
  }, {
    key: "inventoryItemName",
    get: function get() {
      var inventory = find(propEq(this.editCase.InventoryId, 'Id'), this.state.inventory);
      return inventory ? inventory.text : null;
    }
  }, {
    key: "caseTypeOptions",
    get: function get() {
      return this.filterCaseTypesByDisputeInvoice ? this.state.disputeInvoiceCaseTypesOptionsSelector : this.state.caseCategoryCodes;
    }
  }, {
    key: "onSaveSuccess",
    value: function onSaveSuccess() {
      this.closePopup();
      // NOTE: this should be the responsibility of the component that manages the popup instance
      var successMessageKey = this.inEditMode ? CustomerCareLocaleKeys.CASE.UPDATED_SUCCESSFULLY : CustomerCareLocaleKeys.CASE.CREATED_SUCCESSFULLY;
      this.uiNotificationService.success(i18n.translate(successMessageKey), null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
    }
  }, {
    key: "shouldShowFieldError",
    value: function shouldShowFieldError(fieldName) {
      var fieldObject = this.formController[fieldName] || {};
      var $touched = fieldObject.$touched,
        $modelValue = fieldObject.$modelValue,
        _fieldObject$$error = fieldObject.$error,
        $error = _fieldObject$$error === void 0 ? {} : _fieldObject$$error;
      var pattern = $error.pattern,
        required = $error.required;
      return !!(($touched || this.formController.$submitted) && required || $modelValue && pattern);
    }
  }, {
    key: "handleCategoryChange",
    value: function handleCategoryChange() {
      var _this3 = this;
      if (this.editCase.Category) {
        this.categoryDetails = {};
        this.selectedInvoice = {};
        this.editCase.InventoryId = this.inEditMode ? this.editCase.InventoryId : null;
        this.editCase.CaseTemplateId = pathOr(null, ['CaseTemplateId'], this.state.caseTypes.find(function (x) {
          return x.Id === _this3.editCase.Category;
        }));
        this.updateCaseInventoryItem(this.editCase.InventoryId);
        this.actions.updateCaseSelectedCategoryId(this.editCase.Category);
        this._popupLayoutNeedsValidation = true;
        this.validatePopupLayout();
        this.state.customFields.forEach(function (customField) {
          _this3.formFieldLocaleKeyMapping[customField.name] = false;
        });
      } else {
        this.actions.removeCaseSelectedCategoryId();
      }
    }
  }, {
    key: "onPropertyChange",
    value: function onPropertyChange(id, value) {
      this.editCase.AdditionalPropertyValues = filter(function (property) {
        return property.Value !== '' && property.Value !== null && property.Value !== undefined;
      }, append({
        Id: id,
        Value: value
      }, reject(propEq(id, 'Id'), pathOr([], ['AdditionalPropertyValues'], this.editCase))));
    }
  }, {
    key: "validatePopupLayout",
    value: function validatePopupLayout() {
      if (this._popupLayoutNeedsValidation) {
        this.$timeout(this.popupApi.center, 0, false); //Use false to make sure it does not trigger another digest cycle
        this._popupLayoutNeedsValidation = false;
      }
    }
  }, {
    key: "shouldShowResolutionText",
    get: function get() {
      return shouldHaveResolutionText(this.editCase);
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      var _this4 = this;
      // NOTE: apply the validation in the next cycle, so that
      // ng-model-options' {updateOn: 'blur'} is applied first (so we actually
      // adapt the errors, instead of not having any yet)
      this.$timeout(function () {
        _this4.state.customFields.forEach(function (customField) {
          _this4.formFieldLocaleKeyMapping[customField.name] = false;
        });
        _this4.formErrors = _this4.formController ? AngularFormControllerErrorAdapter(_this4.formController, _this4.formFieldLocaleKeyMapping) : [];
      });
    }
  }, {
    key: "handleSubmitForm",
    value: function handleSubmitForm() {
      var _this5 = this;
      if (this.formController.$valid) {
        var action = this.inEditMode ? this.actions.updateCase : this.actions.createCase;
        var transformedCase = transformCaseForService(this.inEditMode, this.editCase, this.categoryDetails);
        if (this.state.caseTypes.find(function (caseType) {
          return caseType.Id === transformedCase.Category && caseType.IsGlobal;
        })) {
          delete transformedCase.InventoryId;
        }
        return action(this.state.currentCustomerId, transformedCase).then(function (payload) {
          _this5.onSaveSuccess();
          _this5.$timeout(function () {
            _this5.actions.stateGo(CASE_DETAILS_STATE_NAME, {
              caseId: payload.Case.Id.Value
            });
          });
        }, function () {
          if (_this5.state.lastAttemptError) {
            _this5.formErrors = [_this5.state.lastAttemptError.translatedMessage];
            _this5.uiNotificationService.error(_this5.state.lastAttemptError.translatedMessage, null, {
              timeOut: NOTIFICATION_TIME_LENGTH
            });
          }
          if (_this5.inEditMode) {
            _this5.actions.retrieveCase(_this5.state.currentCustomerId, pathOr(false, ['case', 'Id', 'Value'], _this5)).catch(function (error) {
              _this5.uiNotificationService.transientError(error.translatedMessage);
            });
          }
        });
      } else {
        this.validateForm();
      }
    }
  }, {
    key: "resetForm",
    value: function resetForm() {
      if (this.case) {
        this.setCase(Immutable(this.case).asMutable({
          deep: true
        }));
        if (this.case.Details && this.case.Details.TroubleCallDetails) {
          this.selectInventoryBySerialNumber(this.case.Details.TroubleCallDetails.SerialNumber);
        }
      } else {
        if (this.caseType) {
          this.setCase({
            Category: this.caseType
          });
        } else {
          this.setCase({});
        }
        if (this.caseDetails) {
          this.updateCaseInventoryItem(pathOr(null, ['Id'], this.caseDetails.inventoryItem));
        } else {
          this.updateCaseInventoryItem(null);
        }
      }
      this.formErrors = [];
      if (this.inEditMode) {
        this.modalTitle = i18n.translate(CustomerCareLocaleKeys.CASE.EDIT_CASE);
        this.saveButtonText = i18n.translate(CustomerCareLocaleKeys.CASE.EDIT_CASE);
      } else {
        this.modalTitle = i18n.translate(CustomerCareLocaleKeys.NEW_CASE);
        this.saveButtonText = i18n.translate(CustomerCareLocaleKeys.CREATE_CASE);
      }
    }
  }, {
    key: "handleInventoryChange",
    value: function handleInventoryChange() {
      this.updateCaseInventoryItem(this.editCase.InventoryId);
    }
  }, {
    key: "updateCaseInventoryItem",
    value: function updateCaseInventoryItem(inventoryItemId) {
      this.actions.updateCaseInventoryItem(inventoryItemId);
      if (this.editCase.Category === CASE_CATEGORIES.TROUBLE_CALL || this.editCase.CaseTemplateId === CASE_CATEGORIES.TROUBLE_CALL) {
        this.categoryDetails = {
          SerialNumber: pathOr(null, ['SerialNumber'], this.state.selectedInventory)
        };
      }
      this.editCase.InventoryId = inventoryItemId;
    }
  }, {
    key: "selectInventoryBySerialNumber",
    value: function selectInventoryBySerialNumber(serialNumber) {
      var item = this.state.inventory.find(function (inventoryItem) {
        return inventoryItem.serialNumber === serialNumber;
      });
      this.editCase.InventoryId = item ? item.Id : null;
      this.updateCaseInventoryItem(item ? item.Id : null);
    }
  }, {
    key: "selectInvoiceAmounts",
    value: function selectInvoiceAmounts() {
      var invoiceNumber = path(['editCase', 'Details', 'InvoiceDisputeDetails', 'InvoiceNumber'], this);
      if (invoiceNumber) {
        var invoice = this.state.invoices.find(function (invoiceItem) {
          return invoiceItem.InvoiceNumber === invoiceNumber;
        });
        this.invoiceAmount = invoice.Balance;
        this.validatePopupLayout();
      }
    }
  }]);
}();
export default {
  bindings: {
    case: '<?',
    caseDetails: '<?',
    caseType: '<?',
    config: '<',
    filterCaseTypesByDisputeInvoice: '<?',
    isInventorySet: '<?'
  },
  template: require('./case.modal.html'),
  controller: CaseModalController,
  controllerAs: 'caseModalController'
};